import { render } from "./monitor.vue?vue&type=template&id=72dd7fae&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=72dd7fae&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-72dd7fae"

export default script